import { Flex } from '@chakra-ui/react';
import DocBoxIcon from 'src/components/Icons/DocBoxIcon';
import Typography from 'src/components/Typography';
import { PrescriptionMedicalStatement } from 'src/services/prescriptionHistory';

interface CertificateItemProps {
  item: PrescriptionMedicalStatement;
}

export function CertificateItem(props: CertificateItemProps) {
  const { item } = props;

  return (
    <Flex gap="10px" key={item.prescriptionMedicalStatementId}>
      <Flex alignSelf="flex-start">
        <DocBoxIcon variantColor="secondary.400" width={23} background={{ color: 'support.surface', padding: 4 }} />
      </Flex>
      <Flex grow={1} flexDirection="column" gap="10px">
        <Typography model="body" size="large" weight="bold">
          {item.type}
        </Typography>
        <Typography model="body" size="large" weight="regular">
          {item.text}
        </Typography>
      </Flex>
    </Flex>
  );
}
